tippy('[data-tippy-template]', {
  arrow: true,
  animation: 'fade',
  theme: 'light',
  content(el) {
    var content = el.querySelector('.tippy-template').innerHTML;
    var container = document.createElement('div');
    container.innerHTML = content;
    return content;
  }
});